import Card from "./Card";
import sunEnergy from "../assets/1stsunergy.png";
import final from "../assets/image.png";
import mapPinIcon from "../assets/mapPin.svg";
import phoneIcon from "../assets/phoneIcon.svg";
import globeIcon from "../assets/globeIcon.svg";

function CardsList({ cardsData }) {
  // Show cards directly if less than 16 items
  if (cardsData.length < 16) {
    return (
      <div className="font-inter text-[#4E5562] flex flex-col">
        {/* First Grid Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 xl:gap-12 mt-7">
          {cardsData.map((card, index) => (
            <Card
              slug={card.slug}
              key={index}
              image={card.logo}
              title={card.company_name}
              remarks={""}
            />
          ))}
        </div>

        {/* Hero Section */}
        {/* <div className="flex flex-col md:flex-row border border-[#CAD0D9] bg-white rounded-lg my-8 md:my-12 xl:my-16 2xl:my-24 h-auto">
          <div className="flex flex-col md:flex-1 p-6 md:p-8 xl:p-12 space-y-6">
            <div className="w-full flex justify-center md:justify-start">
              <img
                src={sunEnergy}
                alt="Sun Energy Logo"
                className="w-3/4 md:w-1/2 xl:w-1/3 h-auto"
              />
            </div>
            <div className="space-y-4 text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start space-x-2 text-lg xl:text-xl">
                <img src={mapPinIcon} alt="Map Pin Icon" className="w-6 h-6 xl:w-8 xl:h-8" />
                <span>Houston, TX</span>
              </div>
              <div className="flex items-center justify-center md:justify-start space-x-2 text-lg xl:text-xl">
                <img src={phoneIcon} alt="Phone Icon" className="w-6 h-6 xl:w-8 xl:h-8" />
                <span>+1 7135 130 423</span>
              </div>
              <div className="flex items-center justify-center md:justify-start space-x-2 text-lg xl:text-xl">
                <img src={globeIcon} alt="Globe Icon" className="w-6 h-6 xl:w-8 xl:h-8" />
                <a
                  href="http://www.firstsunergy.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline text-blue-600"
                >
                  Website
                </a>
              </div>
            </div>
            <div className="space-y-2 text-lg md:text-2xl xl:text-3xl font-medium text-[#4E5562]">
              <p className="text-center md:text-left">
                <span className="font-bold text-[#111827]">Highly reputable</span> clean energy products
              </p>
              <p className="text-center md:text-left">
                & services provider and{" "}
                <span className="font-bold text-[#111827]">global distributor</span>
              </p>
            </div>
          </div>

          <div className="md:flex-1 w-full flex justify-center md:justify-end">
            <img
              src={final}
              alt="Family and Solar Panel"
              className="w-full h-64 md:h-auto xl:h-96 object-cover rounded-b-lg md:rounded-b-none md:rounded-r-lg"
            />
          </div>
        </div> */}

        {cardsData.length > 0 && cardsData[0].ad_image_link ? 
          <button className="p-4 md:p-6 border my-6 rounded-md shadow-md" onClick={() => window.open(cardsData[0].ad_link, '_blank')}>
            <img src={cardsData[0].ad_image_link} className="w-full h-full" alt="ad_image"/>
          </button> :
          <div className="my-6"></div>
        }
      </div>
    );
  }

  // For 16 or more cards, split them into two sections
  let cardsData1 = [];
  let cardsData2 = [];

  cardsData1 = cardsData.slice(0, Math.floor(cardsData.length / 2));
  cardsData2 = cardsData.slice(Math.floor(cardsData.length / 2), cardsData.length);

  return (
    <div className="font-inter text-[#4E5562] flex flex-col">
      {/* First Grid Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 xl:gap-12 mt-7">
        {cardsData1.map((card, index) => (
          <Card
            slug={card.slug}
            key={index}
            image={card.logo}
            title={card.company_name}
            remarks={""}
          />
        ))}
      </div>

      {/* Hero Section */}
      {/* <div className="flex flex-col md:flex-row border border-[#CAD0D9] bg-white rounded-lg my-8 md:my-12 xl:my-16 2xl:my-24 h-auto">
        <div className="flex flex-col md:flex-1 p-6 md:p-8 xl:p-12 space-y-6">
          <div className="w-full flex justify-center md:justify-start">
            <img
              src={sunEnergy}
              alt="Sun Energy Logo"
              className="w-3/4 md:w-1/2 xl:w-1/3 h-auto"
            />
          </div>
          <div className="space-y-4 text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start space-x-2 text-lg xl:text-xl">
              <img src={mapPinIcon} alt="Map Pin Icon" className="w-6 h-6 xl:w-8 xl:h-8" />
              <span>Houston, TX</span>
            </div>
            <div className="flex items-center justify-center md:justify-start space-x-2 text-lg xl:text-xl">
              <img src={phoneIcon} alt="Phone Icon" className="w-6 h-6 xl:w-8 xl:h-8" />
              <span>+1 7135 130 423</span>
            </div>
            <div className="flex items-center justify-center md:justify-start space-x-2 text-lg xl:text-xl">
              <img src={globeIcon} alt="Globe Icon" className="w-6 h-6 xl:w-8 xl:h-8" />
              <a
                href="http://www.firstsunergy.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline text-blue-600"
              >
                Website
              </a>
            </div>
          </div>
          <div className="space-y-2 text-lg md:text-2xl xl:text-3xl font-medium text-[#4E5562]">
            <p className="text-center md:text-left">
              <span className="font-bold text-[#111827]">Highly reputable</span> clean energy products
            </p>
            <p className="text-center md:text-left">
              & services provider and{" "}
              <span className="font-bold text-[#111827]">global distributor</span>
            </p>
          </div>
        </div>

        <div className="md:flex-1 w-full flex justify-center md:justify-end">
          <img
            src={final}
            alt="Family and Solar Panel"
            className="w-full h-64 md:h-auto xl:h-96 object-cover rounded-b-lg md:rounded-b-none md:rounded-r-lg"
          />
        </div>
      </div> */}

      {cardsData.length > 0 && cardsData[0].ad_image_link ? 
        <button className="p-4 md:p-6 border my-6 rounded-md shadow-md" onClick={() => window.open(cardsData[0].ad_link, '_blank')}>
          <img src={cardsData[0].ad_image_link} className="w-full h-full" alt="ad_image"/>
        </button> :
        <div className="my-6"></div>
      }

      {/* Second Grid Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 xl:gap-12 mb-6">
        {cardsData2.map((card, index) => (
          <Card
            slug={card.slug}
            key={index + cardsData1.length}
            image={card.logo}
            title={card.company_name}
            remarks={""}
          />
        ))}
      </div>
    </div>
  );
}

export default CardsList;